module.exports = __webpack_public_path__ + "img/c800230.webp";